module.exports = __webpack_public_path__ + "img/error.9ace902e.svg";